module.exports = __webpack_public_path__ + "static/media/trip-arrow.d3390e3f.svg";